export enum EcmModule{
  ElectronicDocument = 0,
  Document = 1,
  Process = 2
}